export enum UserType {
    /*
     * User created during the checkout process.
     * This user is not yet registered and has not yet set a password.
     */
    Draft = 'Draft',

    /*
     * User has registered and set a password but has not yet verified
     * their email address.
     */
    Registered = 'Registered',

    /*
     * User has verified their email address and is now a fully registered
     * user of the site.
     */
    Verified = 'Verified',
}
